import React, { useMemo } from "react";
import {
  MANUAL_BANK_ACCOUNT,
  formatManualPaymentNote,
} from "../../../../utils/manualPayment";

const ManualBankPayment = ({ invoiceNumber, orderAmount, currencySymbol }) => {
  const note = useMemo(
    () =>
      invoiceNumber
        ? formatManualPaymentNote(invoiceNumber)
        : "Please attach your invoice number in payment reference.",
    [invoiceNumber],
  );

  const openInvoicePage = () => {
    window.open("/paymentslip", "_blank");
  };

  return (
    <div className="w-full flex justify-center items-start min-h-[40vh] h-full px-4">
      <div className="w-full max-w-2xl mt-6 bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
        <div className="px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-[#fff7ed] to-white">
          <h2 className="text-2xl font-bold tracking-wide text-gray-900">
            Manual bank transfer
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            Your invoice page has been opened. Use it for bank transfer details
            and payment reference.
          </p>
        </div>

        <div className="px-6 py-6 space-y-4 text-[15px] leading-relaxed text-gray-900">
          <p>
            <span className="font-semibold">Company Name:</span>{" "}
            {MANUAL_BANK_ACCOUNT.companyName}
          </p>
          <p>
            <span className="font-semibold">A/C no</span>{" "}
            {MANUAL_BANK_ACCOUNT.accountNumber}
          </p>
          <p>
            <span className="font-semibold">Sortcode</span>
            {MANUAL_BANK_ACCOUNT.sortCode}.{MANUAL_BANK_ACCOUNT.bankName}
          </p>

          {invoiceNumber ? (
            <div className="rounded-lg border border-orange-200 bg-orange-50 px-4 py-3">
              <p className="text-xs font-semibold uppercase tracking-wide text-orange-700">
                Your invoice number
              </p>
              <p className="mt-1 text-2xl font-bold tracking-wider text-orange-900 select-all">
                {invoiceNumber}
              </p>
              {orderAmount != null && orderAmount !== "" ? (
                <p className="mt-2 text-sm text-gray-700">
                  Amount to transfer:{" "}
                  <span className="font-semibold">
                    {currencySymbol || ""}
                    {orderAmount}
                  </span>
                </p>
              ) : null}
            </div>
          ) : (
            <p className="text-sm text-amber-700">Generating invoice number…</p>
          )}

          <button
            type="button"
            onClick={openInvoicePage}
            className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2.5 rounded-lg transition-colors"
          >
            Open invoice page
          </button>
        </div>

        <div className="bg-red-600 text-white px-6 py-3 text-sm sm:text-base font-semibold">
          NOTES: {note}
        </div>
      </div>
    </div>
  );
};

export default ManualBankPayment;
